// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__LpvvH","mainTitle":"styles_mainTitle__CgqCp","loading":"styles_loading__HbuWY"};